"use client";

interface VideoBackgroundProps {
  className?: string;
}

export function VideoBackground({ className }: VideoBackgroundProps) {
  return (
    <div
      className={`relative z-0 overflow-hidden pointer-events-none ${className || "absolute inset-0"}`}
    >
      {/* 
        THE CHROMATIC CORE
        Pre-rendered 3D fluid simulation with holographic lighting.
        Overlaying the CSS AmbientCanvas for texture and fallback depth.
      */}
      <video
        autoPlay
        loop
        muted
        playsInline
        aria-hidden="true"
        poster="/images/hero-poster.png" // Static fallback if video fails
        // Light Mode: Exclusion (Softer holographic inversion) | Dark Mode: Screen (Vibrant additive light)
        className="absolute inset-0 w-full h-full object-cover transition-all duration-700 opacity-85 dark:opacity-90 mix-blend-exclusion dark:mix-blend-screen brightness-125 dark:brightness-125 contrast-125 dark:contrast-125 saturate-150 pointer-events-none"
      >
        {/* Prioritize WebM for alpha/transparency support if needed */}
        <source src="/videos/hero-video.webm" type="video/webm" />
      </video>
    </div>
  );
}
